import { useLiveHeadline, useRunStream } from '../../lib/run-stream';
import type { PlaygroundRunStatus } from '../../lib/api';

/**
 * A playground rehearsal's live trail, on the same wire everything else uses.
 *
 * A thin wrapper rather than a second hook: `useRunStream` takes a project id first because the
 * ingestion and automation endpoints are project-scoped, and a rehearsal has no project to be
 * addressed within — it reads the whole hierarchy, which is the thing being tested. Passing a
 * constant here is what keeps the hook, the fold, the timeline component and the SSE endpoint shape
 * shared, rather than inventing a parallel set for one caller.
 */
export function useLiveRunStream(runId: string | null, status: PlaygroundRunStatus | null) {
  const stream = useRunStream('playground', runId, status, 'playground');
  const headline = useLiveHeadline(stream.timeline);
  return { ...stream, headline };
}
